import React from 'react';
import Icon from '../../../components/AppIcon';

const SafetyBadge = ({ badge }) => {
  return (
    <div className="flex items-center gap-3 p-3 md:p-4 bg-muted/50 rounded-lg">
      <div className="w-10 h-10 md:w-12 md:h-12 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
        <Icon name={badge?.icon} size={20} className="text-success" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm md:text-base font-semibold text-foreground">
          {badge?.title}
        </p>
        <p className="text-xs text-muted-foreground">
          {badge?.description}
        </p>
      </div>
    </div>
  );
};

export default SafetyBadge;